export default "__VITE_ASSET__D5WGaV0J__"